/* eslint-disable */
// import { defaultClient as apolloClient } from "../../main";
import listing from "@/apollo/packages/sightseeing/listing.gql";
import create_sight_seeing from "@/apollo/packages/sightseeing/create_update.gql";
import details from "@/apollo/packages/sightseeing/sightseeing_id.gql";

export const state = () => ({
  listing: [],
  is_loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 May 2024 | 10:49AM
   * @param {*} state
   * @param {*} value
   */
  setListing(state, value) {
    state.listing = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 09 Nov 2024 | 01:59PM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.is_loading = value;
  },
  /**
   * @description
   * @author Lalit Verma
   * @date 09 Nov 2024 | 01:58PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 May 2024 | 10:49AM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }, search_by) {
    commit("setListing", []);
    commit("setLoading", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { search_by } })
        .then(({ data }) => {
          commit("setListing", data.pkgSightseeing);
          resolve(data.pkgSightseeing);
          commit("setLoading", false);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },

  /**
   * @description
   * @author Lalit Verma
   * @date 09 Nov 2024 | 02:00PM
   * @param {*} __
   * @param {*} _id
   * @returns {*}
   */
  details(__, _id) {
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .query({ query: details, variables: { _id } })
        .then(({ data }) => resolve(data.pkgSightseeingById))
        .catch((error) => reject(error));
    });
  },

  /**
   * @description
   * @author Lalit Verma
   * @date 09 Nov 2024 | 02:02PM
   * @param {*} { commit }
   * @param {*} data
   * @returns {*}
   */
  create({ commit }, data) {
    commit("setCreating", true);
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.$apolloClient.mutate({ mutation: create_sight_seeing, variables: { data: data } });
        resolve(response.data.sightSeeingCreate);
        commit("setCreating", false);
      } catch (err) {
        commit("setCreating", false); // Correctly set to false here
        reject(err);
      }
    });
  }
};

export const getters = {
  listing: (state) => state.listing,
  is_loading: (state) => state.is_loading,
  creating: (state) => state.creating
};
